import _mixin from './_mixin'
export default {
  name: 'BaseImage',
  cnName: '图片',
  type: 'base',
  draggable: true,
  // 属性相关
  props: {
    src: 'https://rescdn-crash.ssjj.cn/website/2023/10/13/c08eb21a2f63df51a7ac375f34cade54.jpg',
    width: '',
    height: '',
    link: ''
  },
  propsDesc: [{
    target: 'src',
    label: '图片地址'
  }, {
    target: 'width',
    label: '宽'
  }, {
    target: 'height',
    label: '高'
  }, {
    target: 'link',
    label: '跳链'
  }],

  // 样式相关
  styles: {
    ..._mixin.styles,
    position: 'absolute',
    left: '0',
    top: '0',
    display: 'inline-block'
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc,
    {
      target: 'mouseover',
      label: '鼠标移入'
    }
  ],

  methods: [
    ..._mixin.methods
  ]
}
